import React, {Component} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Input,
    Row,
    Col
} from 'reactstrap'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import {Query, Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import projectClientInvoiceQuery from '../../../queries/client_side/project_client_invoice'
import editProjectClientInvoiceLocalMutation from '../../../queries/client_side/mutations/edit_project_client_invoice'
import updateProjectClientInvoicesLocalMutation
    from '../../../queries/client_side/mutations/update_project_client_invoices'

export default class ProjectInvoiceBreakdownModal extends Component {

    state = {
        activeTab: 0
    }

    toggle = (activeTab) => {
        this.setState({activeTab})
    }

    render() {

        const {isOpen, toggle, onSave} = this.props

        return (
            <Query query={projectClientInvoiceQuery}>
                {({data}) => {

                    const {project_id, name, project_clients, project_client_budgets} = data.projectClientInvoice

                    return (
                        <Modal isOpen={isOpen} toggle={toggle} size="xl">
                            <ModalHeader>{project_id}: {name}</ModalHeader>
                            <ModalBody>
                                <div>
                                    <Nav tabs>
                                        {project_clients && project_clients.map(({client}, index) => {
                                            return (
                                                <NavItem key={client.client_id}>
                                                    <NavLink
                                                        className={classnames({active: this.state.activeTab === index})}
                                                        onClick={() => {
                                                            this.toggle(index)
                                                        }}
                                                    >
                                                        {client.name}
                                                    </NavLink>
                                                </NavItem>
                                            )
                                        })}
                                    </Nav>
                                    <TabContent
                                        activeTab={this.state.activeTab}>

                                        {project_clients && project_clients.map(({client}, index) => {
                                            return (
                                                <Mutation mutation={editProjectClientInvoiceLocalMutation}>
                                                    {(editProjectClientInvoiceLocalMutationFunc) => (
                                                        <TabPane tabId={index} key={client.client_id}>
                                                            {project_client_budgets && project_client_budgets
                                                                .filter(budget => budget.client_id === client.client_id)
                                                                .map((budget, index) => {
                                                                return (
                                                                    <Row className="pt-2 pb-2" form key={index}>
                                                                        <Col sm="9">
                                                                            <Input
                                                                                size="sm"
                                                                                value={budget.budget_label}
                                                                                onChange={(evt) => {
                                                                                    editProjectClientInvoiceLocalMutationFunc({
                                                                                        variables: {
                                                                                            client_id: client.client_id,
                                                                                            project_activity_budget_id: budget.project_activity_budget_id,
                                                                                            description: evt.target.value,
                                                                                            amount: budget.amount_to_invoice
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col sm="3">
                                                                            <Input
                                                                                size="sm"
                                                                                type="number"
                                                                                value={budget.amount_to_invoice}
                                                                                onChange={(evt) => {
                                                                                    editProjectClientInvoiceLocalMutationFunc({
                                                                                        variables: {
                                                                                            client_id: client.client_id,
                                                                                            project_activity_budget_id: budget.project_activity_budget_id,
                                                                                            description: budget.budget_label,
                                                                                            amount: evt.target.value
                                                                                        }
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>

                                                                )
                                                            })}
                                                        </TabPane>
                                                    )}

                                                </Mutation>
                                            )

                                        })}
                                    </TabContent>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Mutation mutation={updateProjectClientInvoicesLocalMutation}>
                                    {(updateProjectClientInvoicesLocalMutationFunc) => (
                                        <Button
                                            size="sm"
                                            color="success"
                                            onClick={() => {
                                                onSave()
                                                updateProjectClientInvoicesLocalMutationFunc({variables: {data: data.projectClientInvoice}})

                                            }}
                                        >
                                            <FontAwesomeIcon
                                                color="#fff"
                                                icon="save"/>{' '}
                                            Save
                                        </Button>
                                    )}

                                </Mutation>
                            </ModalFooter>
                        </Modal>
                    )

                }}

            </Query>
        )

    }

}

ProjectInvoiceBreakdownModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
}